import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

// Types
import { EditStylesProps } from '@/types';

const EditMainChartStylesForm: FC<EditStylesProps> = ({
  register,
  chartData,
  control,
}) => {
  const headerBackground = useWatch({
    control,
    defaultValue: '#FFFFFF',
    name: 'headerBackground',
  });
  const headerFontColor = useWatch({
    control,
    defaultValue: '#000000',
    name: 'headerFontColor',
  });

  return (
    <fieldset className="flex flex-col bg-white shadow-lg p-6 rounded-lg my-6 ring-1 ring-gray-200 min-w-[20rem] md:max-w-sm w-full h-fit">
      <legend className="text-xl pb-2 font-bold float-left">
        Gráfica de factor:
      </legend>
      <div className="flex flex-col py-1">
        <label htmlFor="header-background">Fondo del encabezado:</label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">{headerBackground.toUpperCase()}</span>
          <input
            type="color"
            id="header-background"
            disabled={chartData.length === 0}
            className="w-6 h-6 rounded-lg cursor-pointer"
            {...register('headerBackground')}
          />
        </div>
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="main-chart-width">Anchura de la gráfica:</label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="main-chart-width"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('mainChartWidth', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="main-chart-height">Altura de la gráfica:</label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="main-chart-height"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('mainChartHeight', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="header-font-size">
          Tamaño de la fuente (en pixeles):
        </label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="header-font-size"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('headerFontSize', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="header-font-color">Color de la fuente:</label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">{headerFontColor.toUpperCase()}</span>
          <input
            type="color"
            id="header-font-color"
            disabled={chartData.length === 0}
            className="w-6 h-6 rounded-lg cursor-pointer"
            {...register('headerFontColor')}
          />
        </div>
      </div>
    </fieldset>
  );
};

export default EditMainChartStylesForm;
